import React from 'react';
import useFlatMeterTariffs from '../../../queries/useFlatMeterTariffs';
import { baseQueryOptions } from '../MeterForm/constants';
import { Spin } from 'antd';

const TarifView = ({ tarifId }) => {
  const { data, isFetching } = useFlatMeterTariffs(baseQueryOptions);

  const tarif = data?.find((item) => item.id === tarifId);

  return <>{isFetching ? <Spin /> : tarif?.name}</>;
};

export default TarifView;
